/**
 * Klaviyo form terms dropdown (homepage form WhpDzn).
 *
 * Behavior:
 * - If email input is empty: terms hidden
 * - On focus: terms shown
 * - On input (has text): terms shown
 * - On blur with empty value: terms hidden
 *
 * Klaviyo injects markup asynchronously, so we attach via observer + retries.
 */
(function klaviyoTermsDropdown() {
  const EMAIL_INPUT_SELECTOR =
    ".klaviyo-form [data-testid='klaviyo-form-WhpDzn'] [data-testid='form-row'] [data-testid='form-component'] input[type='email']";

  const TERMS_SELECTOR = '.homepage-form-section .mm-klaviyo-terms';
  const TERMS_OPEN_CLASS = 'is-open';

  /** @type {WeakSet<HTMLInputElement>} */
  const boundInputs = new WeakSet();

  /** @param {HTMLInputElement} input */
  function initForInput(input) {
    if (boundInputs.has(input)) return false;
    boundInputs.add(input);

    const homepageSection =
      input.closest('.homepage-form-section') ||
      document.querySelector('.homepage-form-section');

    const termsEl =
      (homepageSection && homepageSection.querySelector('.mm-klaviyo-terms')) ||
      document.querySelector(TERMS_SELECTOR);
    if (!termsEl) return false;

    const setState = () => {
      const hasValue = input.value.trim().length > 0;
      const isFocused = document.activeElement === input;
      const shouldOpen = isFocused || hasValue;
      termsEl.classList.toggle(TERMS_OPEN_CLASS, shouldOpen);
      termsEl.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    };

    input.addEventListener('focus', setState, { passive: true });
    input.addEventListener('input', setState, { passive: true });
    input.addEventListener(
      'blur',
      () => {
        if (!input.value.trim()) {
          termsEl.classList.remove(TERMS_OPEN_CLASS);
          termsEl.setAttribute('aria-hidden', 'true');
        }
      },
      { passive: true }
    );

    // Initial state.
    setState();
    return true;
  }

  function scanAndInit() {
    const inputs = document.querySelectorAll(EMAIL_INPUT_SELECTOR);
    let any = false;
    inputs.forEach((el) => {
      if (el instanceof HTMLInputElement) {
        any = initForInput(el) || any;
      }
    });
    return any;
  }

  function start() {
    // Quick attempt immediately.
    scanAndInit();

    // Retry loop in case observer misses first paint.
    let tries = 0;
    const maxTries = 40; // ~20s at 500ms
    const interval = window.setInterval(() => {
      tries += 1;
      const found = scanAndInit();
      if (found || tries >= maxTries) {
        window.clearInterval(interval);
      }
    }, 500);

    // MutationObserver for Klaviyo async injection.
    const obs = new MutationObserver(() => {
      if (scanAndInit()) {
        // Keep observing in case Klaviyo re-renders, but avoid heavy work.
      }
    });
    if (document.body) {
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

